import styles from './InstructionsModal.module.scss';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

function InstructionsModal({ show, handleClose }) {
  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={handleClose}
      className={`${styles.instruct_modal} instruct_modal`}
    >
      <Modal.Header className={`${styles.instruct_modal_hd} instruct_modal_hd`}>
        <Modal.Title />
        <Button onClick={handleClose}>
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.6665 1.33333L14.9998 14.6667M1.6665 14.6667L14.9998 1.33333"
              stroke="#FF0000"
              strokeWidth="2.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>
      <Modal.Body className={`${styles.instruct_body} instruct_body`}>
        <h1 className={styles.modal_title}>
          How to Get Stripe Publishable Key, Secret Key, and Webhook Secret Key
        </h1>
        <h1>1. Log in to Stripe Dashboard </h1>
        <ul>
          <li>
            Go to <a href="">https://dashboard.stripe.com</a> and log in to your account.
          </li>
        </ul>
        <h1>2. Get Publishable Key & Secret Key</h1>
        <ul>
          <li>
            From the left sidebar, go to <strong>Developers &gt; API keys</strong>.
          </li>
          <li>You&apos;ll find:</li>
          <ul className={styles.inner_ul}>
            <li>
              <strong>Publishable key</strong> (starts with <span>pk_...</span>)
            </li>
            <li>
              <strong>Secret key</strong> (starts with <span>sk_...</span>)
            </li>
          </ul>
        </ul>
        <p>
          Use <strong>test mode</strong> for development. Toggle it at the top-right of the
          dashboard.
        </p>
        <h1>3. Get Webhook Secret Key</h1>
        <ul>
          <li>
            Go to <strong>Developers &gt; Webhooks</strong>.
          </li>
          <li>Click on your webhook endpoint or create a new one.</li>
          <li>After creating, click on the webhook to view the details.</li>
          <li>
            You&apos;ll see the <strong>Signing secret</strong> — this is your{' '}
            <strong>Webhook secret key</strong> (starts with <span>whsec_...</span>).
          </li>
        </ul>
        <h1 className={styles.modal_title}>How to Update Webhook URL</h1>
        <ul>
          <li>
            Go to <strong>Developers &gt; Webhooks</strong>.
          </li>
          <li>Click on the existing webhook you want to update.</li>
          <li>
            Click <strong>Edit endpoint</strong>.
          </li>
          <li>
            Update the <strong>URL</strong> to your new webhook destination.
          </li>
          <li>Save changes.</li>
        </ul>
      </Modal.Body>
    </Modal>
  );
}

InstructionsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default InstructionsModal;
